import { connect } from "react-redux";
import HotoChangeAssignee from "./hotoChangeAsignee";
import {fetchPmTicketAssignee} from "services/redux/maintenance/pmTicket/action";
import {getAllHotoDetails } from "services/redux/maintenance/hoto/action";

import { bindActionCreators } from "redux";
import {
  getHotoAssigneeList,
  updateHotoAssignee
} from "services/redux/brandActivtion/sitesListing/action";

const mapStateToProps = (state) => ({
  assigneeList: state.baSiteListingReducer.hotoAssigneeList,
  pmTicketAssignee: state.pmTicketReducer.pmTicketAssignee,
  hotoDetails: state.HotoReducer.hotoAllDetails,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getHotoAssigneeList,
      fetchPmTicketAssignee,
      updateHotoAssignee,
      getAllHotoDetails
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(HotoChangeAssignee);
